import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/communication/phone-log/query/', 'dddd');

tbl.add(new Xtc('recorded_time', 'Recorded time').renderSlot('recorded'))
tbl.add(new Xtc('date', 'Date').renderSlot('time'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('subject', 'Subject'))
tbl.add(new Xtc('from_user', 'From').renderSlot('from'))
tbl.add(new Xtc('to_users', 'To').renderSlot('to'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

